import { ReviewModel } from '../typings/reviews';
import {
  FeatureAppTrackingManager,
  getDefaultTrackingEvent,
} from '../services/use-tracking-manager';

export const onHandleBasicVehicleLink = (
  href: string,
  name: string,
  trackingManager?: FeatureAppTrackingManager,
  reviews?: ReviewModel,
) => {
  const customEvent = getDefaultTrackingEvent();

  customEvent.link = {
    ...customEvent.link,
    name,
    url: href,
    newTab: false,
  };
  customEvent.questionnaire = {
    ...customEvent.questionnaire,
    QuestionAnswerSet: reviews?.averageRating
      ? {
          id: 'Review',
          version: '1',
          content: [
            {
              question: 'Rating',
              id: '1',
              answer: [
                {
                  type: 'string',
                  value: reviews.averageRating,
                },
              ],
            },
          ],
        }
      : undefined,
  };
  trackingManager &&
    trackingManager.trackInventoryGlobalEvent(
      'VWBasic_VehicleLink_Click',
      reviews,
      customEvent,
    );
};

/**
 * Throw trigger when carousel is loaded
 * @param offer
 * @param trackingManager
 */
export const onHandleCarouselLoaded = (
  trackingManager?: FeatureAppTrackingManager,
  store?: ReviewModel,
) => {
  // Tracking section on component mount
  let customEvent = getDefaultTrackingEvent();
  customEvent.link = {
    ...customEvent.link,
    url: 'Loaded carousel',
    name: `load carousel`,
    newTab: false,
  };
  trackingManager &&
    trackingManager.trackInventoryGlobalEvent(
      'VWBasic_SliderElement_Load',
      store,
      customEvent,
    );
};

/**
 * Tracking function for slider actions
 * @param type
 * @param direction
 */
export const onSlideActionTracking = (
  type: 'click' | 'swipe',
  direction: string,
  trackingManager?: FeatureAppTrackingManager,
  store?: ReviewModel,
) => {
  const event =
    type === 'click' ? 'VWBasic_Link_Click' : 'VWBasic_Element_Swipe';
  let customEvent = getDefaultTrackingEvent();
  customEvent.link = {
    ...customEvent.link,
    url: `Move carousel to ${direction}`,
    name: direction,
  };
  // customEvent.questionnaire = {
  //   ...customEvent.questionnaire,
  //   QuestionAnswerSet: store?.averageRating
  //     ? [`${store.averageRating}`]
  //     : undefined
  // };
  trackingManager &&
    trackingManager.trackInventoryGlobalEvent(event, store, customEvent);
};

export const onHandleLayerLoadTrackEvent = (
  type: 'load' | 'layerLoad',
  trackingManager: FeatureAppTrackingManager,
  store?: ReviewModel,
) => {
  const customEvent = getDefaultTrackingEvent();

  customEvent.filter = {
    ...customEvent.filter,
    filterlist: [
      {
        type: 'single_value',
        name: 'RTG',
        values: ['filterbyrating'],
      },
      {
        type: 'single_value',
        name: 'PUB',
        values: ['sortybyallreviews'],
      },
    ],
  };
  customEvent.questionnaire = {
    ...customEvent.questionnaire,
    QuestionAnswerSet: store?.averageRating
      ? {
          id: 'Review',
          version: '1',
          content: [
            {
              question: 'Rating',
              id: '1',
              answer: [
                {
                  type: 'string',
                  value: store.averageRating,
                },
              ],
            },
          ],
        }
      : undefined,
  };
  trackingManager.trackInventoryGlobalEvent(
    type === 'load' ? 'VWBasic_Review_Load' : 'VWBasic_ReviewLayer_Load',
    store,
    customEvent,
  );
};

export const onHandleLayerCloseTrackEvent = (
  trackingManager: FeatureAppTrackingManager,
  store?: ReviewModel,
) => {
  const customEvent = getDefaultTrackingEvent();

  customEvent.link = {
    ...customEvent.link,
    name: 'Close Review Modal',
    url: 'Close Review Modal',
  };

  trackingManager.trackInventoryGlobalEvent(
    'VWBasic_LayerClose_Click',
    store,
    customEvent,
  );
};

export const onHandleFilterSelectTrackingEvent = (
  filterType: string,
  filterName?: string,
  values?: string[] | undefined[],
  trackingManager?: FeatureAppTrackingManager,
  store?: ReviewModel,
) => {
  const customEvent = getDefaultTrackingEvent();
  customEvent.filter = {
    ...customEvent.filter,
    type: 'single_value',
    name: filterType,
    values: [filterName],
  };

  trackingManager &&
    trackingManager.trackInventoryGlobalEvent(
      'VWBasic_FilterSelect_Click',
      store,
      customEvent,
    );
};

export const onHandleReviewsReloadTrackingEvent = (
  rating: string,
  reverse: boolean,
  isSorted: boolean,
  numberOfResults: number,
  trackingManager?: FeatureAppTrackingManager,
  store?: ReviewModel,
) => {
  const customEvent = getDefaultTrackingEvent();

  customEvent.filter = {
    ...customEvent.filter,
    numberOfResults,
    filterlist: [
      {
        type: 'single_value',
        name: 'RTG',
        values: [rating + '_stars'],
      },
      {
        type: 'single_value',
        name: 'PUB',
        values: [reverse ? 'oldest' : 'newest'],
      },
    ],
    sortOrder: [
      {
        sortby: reverse ? 'Oldest' : 'Newest',
        order: 'desc',
      },
    ],
  };

  trackingManager &&
    trackingManager.trackInventoryGlobalEvent(
      'VWBasic_FilterSearchResult_Load',
      store,
      customEvent,
    );
};

export const onHandleCollapseTextEventTracking = (
  action: string,
  trackingManager,
  reviews,
) => {
  let customTracking = getDefaultTrackingEvent();
  customTracking.link = { ...customTracking.link, url: action, name: action };
  trackingManager.trackInventoryGlobalEvent(
    'VWBasic_Link_Click',
    reviews,
    customTracking,
  );
};
